// Aggressive Safe Content Protection - Preserves ALL Navigation
(function() {
  'use strict';
  
  // Check for protected content areas
  function isProtectedArea(element) {
    if (!element) return false;
    
    return element.closest('.product__description') ||
           element.closest('.rich-text__content') ||
           element.closest('.specification-table') ||
           element.closest('.rte') ||
           element.closest('.gallery-zoom-modal') ||
           element.closest('.modal') ||
           (element.closest('.product') && element.tagName === 'IMG' && 
            !element.closest('.nav') && !element.closest('.header') && 
            !element.closest('.menu') && !element.closest('.drawer') && 
            !element.closest('.cart') && !element.closest('.breadcrumb'));
  }
  
  // Always allow interactive elements
  function isInteractiveElement(element) {
    if (!element) return false;
    
    return element.tagName === 'A' || 
           element.tagName === 'BUTTON' || 
           element.tagName === 'INPUT' || 
           element.tagName === 'SELECT' || 
           element.tagName === 'TEXTAREA' ||
           element.hasAttribute('href') ||
           element.hasAttribute('onclick') ||
           element.hasAttribute('role') ||
           element.hasAttribute('data-drawer') ||
           element.closest('a') ||
           element.closest('button') ||
           element.closest('.nav') ||
           element.closest('.header') ||
           element.closest('.footer') ||
           element.closest('.form') ||
           element.closest('.cart') ||
           element.closest('.menu') ||
           element.closest('.drawer') ||
           element.closest('.btn') ||
           element.closest('[role]') ||
           element.closest('[href]') ||
           element.closest('.gallery-zoom__controls') ||
           element.closest('.gallery-zoom__thumbs') ||
           element.closest('.media-ctrl__btn') ||
           element.closest('.js-close-modal');
  }
  
  // Block context menu
  document.addEventListener('contextmenu', function(e) {
    if (isProtectedArea(e.target) && !isInteractiveElement(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, true);
  
  // Block middle-click (opens in new tab)
  document.addEventListener('mousedown', function(e) {
    if (e.button === 1 && e.target.tagName === 'IMG' && isProtectedArea(e.target) && !isInteractiveElement(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, true);
  
  // Block auxiliary click (middle-click alternative)
  document.addEventListener('auxclick', function(e) {
    if (e.target.tagName === 'IMG' && isProtectedArea(e.target) && !isInteractiveElement(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, true);
  
  // Block drag events on images
  document.addEventListener('dragstart', function(e) {
    if (e.target.tagName === 'IMG' && isProtectedArea(e.target) && !isInteractiveElement(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, true);
  
  // Block text selection events
  document.addEventListener('selectstart', function(e) {
    if (isProtectedArea(e.target) && !isInteractiveElement(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, true);
  
  // Block keyboard shortcuts
  document.addEventListener('keydown', function(e) {
    const target = e.target || document.activeElement;
    
    // Always allow if interactive element
    if (isInteractiveElement(target)) {
      return true;
    }
    
    // Block on protected content
    if (isProtectedArea(target)) {
      if (
        // Copy/paste/select shortcuts
        (e.ctrlKey || e.metaKey) && (e.key === 'a' || e.key === 'c' || e.key === 'v' || e.key === 'x' || e.key === 's' || e.key === 'u') ||
        // Developer tools
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) ||
        // Refresh
        e.key === 'F5' ||
        ((e.ctrlKey || e.metaKey) && e.key === 'r') ||
        // View source
        ((e.ctrlKey || e.metaKey) && e.key === 'u') ||
        // Open in new tab/window shortcuts
        ((e.ctrlKey || e.metaKey) && e.key === 't') ||
        ((e.ctrlKey || e.metaKey) && e.key === 'n') ||
        (e.shiftKey && e.key === 'Enter')
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }
  }, true);
  
  // Disable print for protected content
  window.addEventListener('beforeprint', function(e) {
    const protectedElements = document.querySelectorAll('.product__description, .rich-text__content, .specification-table, .rte, .gallery-zoom-modal, .modal');
    protectedElements.forEach(el => {
      el.style.display = 'none';
    });
  });
  
  window.addEventListener('afterprint', function(e) {
    const protectedElements = document.querySelectorAll('.product__description, .rich-text__content, .specification-table, .rte, .gallery-zoom-modal, .modal');
    protectedElements.forEach(el => {
      el.style.display = '';
    });
  });
})(); 